import styled, { css } from 'styled-components';

import { cssBreakpoints, gutterWidth, maxWidth } from 'theme/theme';

const cmsBodyContainerRegularWidthCss = css`
  max-width: calc(740px + var(--cms-body-container-gutter-width) * 2);
  padding: 0 var(--cms-body-container-gutter-width);
`;

const cmsBodyContainerRegularWideWidthCss = css`
  max-width: calc(952px + var(--cms-body-container-gutter-width) * 2);
  padding: 0 var(--cms-body-container-gutter-width);
`;

const cmsBodyContainerExpandedWidthCss = css`
  padding: 0 var(--cms-body-container-gutter-width);

  @media screen and (min-width: ${cssBreakpoints.mdUp}) {
    max-width: ${maxWidth[2]}px;
  }

  @media screen and (min-width: ${cssBreakpoints.lgUp}) {
    max-width: ${maxWidth[3]}px;
  }
`;

export enum CmsBodyContainerWidth {
  NARROW_LAYOUT = 'NARROW_LAYOUT',
  NARROW_LAYOUT_WIDE = 'NARROW_LAYOUT_WIDE',
  PAGE_LAYOUT = 'PAGE_LAYOUT',
  FULL = 'FULL',
}

export const CmsBodyContainer = styled.div<{
  $width: CmsBodyContainerWidth;
}>`
  width: 100%;
  margin: 0 auto;

  --cms-body-container-gutter-width: ${gutterWidth / 2}px;

  @media screen and (min-width: ${cssBreakpoints.lgUp}) {
    --cms-body-container-gutter-width: ${gutterWidth}px;
  }

  ${(props) => {
    switch (props.$width) {
      case CmsBodyContainerWidth.NARROW_LAYOUT:
        return cmsBodyContainerRegularWidthCss;
      case CmsBodyContainerWidth.NARROW_LAYOUT_WIDE:
        return cmsBodyContainerRegularWideWidthCss;
      case CmsBodyContainerWidth.PAGE_LAYOUT:
        return cmsBodyContainerExpandedWidthCss;
      case CmsBodyContainerWidth.FULL:
        return '';
    }
  }}
`;
